import escapeRegex from 'escape-string-regexp';

import { Text as ChakraText, Link } from '@bonusly/design-system';

import { Bonus } from '../../../../types/bonus';
import { populateEmojis } from '../../../../utils/emoji';
import { useHashtagLink } from '../../../bonus-feed/features/recognition/hooks/useHashtagLink';
import { ProfileLink } from '../../../profile/components/profile-link';
import { Chip } from '../Chip';

export const Amount = (text: string) => (
	<Chip data-testid="amount-chip" as="span">
		{text}
	</Chip>
);

export const Text = (text: string, highlight?: string) => {
	const emojiText = populateEmojis(text);

	if (!highlight) return <>{emojiText}</>;

	const parts = emojiText.split(new RegExp(`(${escapeRegex(highlight)})`, 'gi'));
	return (
		<>
			{parts.map((part, i) =>
				part.toLowerCase() === highlight.toLowerCase() ? (
					<ChakraText key={i} as="strong" fontWeight="semibold" display="inline">
						{part}
					</ChakraText>
				) : (
					part
				)
			)}
		</>
	);
};

export const Mention = (text: string, bonus: Bonus) => {
	const user = bonus?.receivers?.find(({ slug }) => slug && text.includes(slug));

	if (!user) {
		return Text(text);
	}

	return (
		<ProfileLink userId={user.id} color="text.interactive" fontWeight="medium">
			{text}
		</ProfileLink>
	);
};

export const Hashtag = (text: string) => {
	const hashtagLinkUrl = useHashtagLink(text);

	return (
		<Link href={hashtagLinkUrl} color="hashtag.fg" fontWeight="medium" _hover={{ color: 'hashtag.fgHover' }}>
			{text}
		</Link>
	);
};
